import { FlexLanding } from "@components/flex/FlexLanding";
import { FLEX } from "@/lib/site";
import { GetStaticProps } from "next";

const FlexPage = () => <FlexLanding />;

export const getStaticProps: GetStaticProps = async () =>
  FLEX.live ? { props: {} } : { notFound: true };

export default FlexPage;
